var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_13179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4518 5.71568C6.93514 5.23236 7.70042 5.20219 8.21888 5.62522L8.319 5.71568L12.9856 10.3823L17.6523 5.71568L17.7524 5.62522C18.2709 5.20232 19.0362 5.23239 19.5195 5.71568C20.0026 6.19898 20.0328 6.96435 19.6099 7.48276L19.5195 7.58288L14.8528 12.2495L19.5195 16.9161C20.035 17.4316 20.0349 18.2678 19.5195 18.7833C19.004 19.2988 18.1678 19.2988 17.6523 18.7833L12.9856 14.1167L8.319 18.7833C7.80357 19.2988 6.96731 19.2987 6.4518 18.7833C5.93631 18.2679 5.93631 17.4316 6.4518 16.9161L11.1184 12.2495L6.4518 7.58288L6.36134 7.48276C5.93831 6.96429 5.96847 6.19901 6.4518 5.71568Z",
    fill: "url(#paint0_linear_2220_13179)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2220_13179",
    x1: 12.9856,
    y1: 5.20933,
    x2: 12.9856,
    y2: 19.2897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FED659"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_13179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.985352 0.249512)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.252dfcd19c265163f560494f3447603c.svg";
export { ForwardRef as ReactComponent };